import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from '../services/toast.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private toastService = inject(ToastService);

  private readonly GLOBAL_HANDLED_STATUSES: number[] = [400, 404, 405, 500];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse): Observable<never> => {
        if (error.error?.errorCode === 'DASHBOARD_ERROR') {
          const message: string = error.error?.message ?? 'Dashboard Fehler';
          this.toastService.showToast(message, 'error');
          return throwError(() => error);
        }

        let message: string = 'Ein unbekannter Fehler ist aufgetreten.';
        const headers: HttpHeaders = error.headers;
        const handledByGlobal: boolean =
          headers.get('X-Handled-By') === 'GlobalErrorHandler' && this.GLOBAL_HANDLED_STATUSES.includes(error.status);

        if (handledByGlobal) {
          if (typeof error.error === 'string') {
            try {
              const parsed: unknown = JSON.parse(error.error);
              if (typeof parsed === 'object' && parsed !== null && 'message' in parsed) {
                message = (parsed as { message: string }).message;
              }
            } catch (_e: unknown) {
              // ignore parse error
            }
          } else if (typeof error.error === 'object' && error.error !== null) {
            if ('message' in error.error && typeof error.error.message === 'string') {
              message = error.error.message;
            }
          } else if (error.status === 0) {
            message = 'Keine Verbindung zum Server.';
          }

          this.toastService.showToast(message, 'error');
        }

        return throwError(() => error);
      })
    );
  }
}
